module.exports = __webpack_public_path__ + "static/img/ent-detail-17.9dc4ea0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-17.jpg
// module id = i9Jc
// module chunks = 51